import { render, staticRenderFns } from "./VRButton.vue?vue&type=template&id=52aca6fa"
import script from "./VRButton.vue?vue&type=script&lang=js"
export * from "./VRButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports